;(function () {
    /**
     * Controls the generation of the data required in the data layer
     *
     * @constructor
     */
    function OrderDataLayerController() {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        this.object = null

        this.defaultCurrency = 'EUR'

        this.defaultTotalOrderValue = 0

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var currency = _this.defaultCurrency
            var objectId = new Date().getTime()
            var totalOrderValue = _this.defaultTotalOrderValue

            _this.object = new OrderDataLayerObject(currency, objectId, totalOrderValue)
        }

        this.generateDataLayerObjectFromCart = function (cart) {
            jsonCart = JSON.parse(cart)

            for (id in jsonCart) {
                _this.object.addProduct(new OrderDataLayerProduct(id, jsonCart[id]))
            }

            return _this.object.getDataLayerObject()
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    /**
     * Structures the data required in the data layer for a single sample order
     *
     * @param currencyCode
     * @param orderId
     * @param countryCode
     * @param revenue
     * @constructor
     */
    function OrderDataLayerObject(currencyCode, orderId, revenue) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * Holds the order data object
         * @type {{}}
         */
        this.orderData = {}

        /**
         * Array of OrderDataLayerProduct
         * @type {Array}
         */
        this.products = []

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.products = []

            _this.orderData = {
                event: 'eec.transaction',
                information: {},
                ecommerce: {
                    currencyCode: currencyCode,
                    purchase: {
                        actionField: {
                            id: orderId,
                            affiliation: '_Webseite',
                            revenue: revenue,
                        },
                        products: [],
                    },
                },
            }
        }

        /**
         * Adds a OrderDataLayerProduct
         * @param product
         */
        this.addProduct = function (product) {
            _this.products.push(product)
        }

        /**
         * Returns the data object to be used in data layer
         * Sets the language and the product objects
         * @returns {*}
         */
        this.getDataLayerObject = function () {
            if (_this.products.length > 0) {
                _this.setCountryCode(_this.products[0].getLanguage())
            }
            _this.products.forEach(function (product) {
                _this.orderData['ecommerce']['purchase']['products'].push(product.getDataLayerProduct())
            })
            return _this.orderData
        }

        this.setCountryCode = function (countryCode) {
            _this.orderData['ecommerce']['purchase']['actionField']['affiliation'] = countryCode + '_Webseite'
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    /**
     * Structures the data required for a single product in the data layer
     *
     * @param id
     * @param cartItem
     * @constructor
     */
    function OrderDataLayerProduct(id, cartItem) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        this.productData = {}

        this.defaultPrice = 0

        this.defaultBrand = 'Creaton'

        this.defaultDimensionFour = 'Sample'

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.productData = {
                id: id,
                name: cartItem['product-title'],
                category: cartItem['product-category'],
                price: _this.defaultPrice,
                brand: _this.defaultBrand,
                variant: cartItem['color-title'],
                quantity: cartItem['amount'],
                countryCode: cartItem['product-country'],
                dimension4: _this.defaultDimensionFour,
            }
        }

        this.getDataLayerProduct = function () {
            return _this.productData
        }

        this.getLanguage = function () {
            return _this.productData['countryCode']
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Creaton = window.Creaton || {}

    window.Creaton.OrderDataLayerController = OrderDataLayerController
})()
